// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"uma-z"};